module.exports = __webpack_public_path__ + "img/notice-modal-pt-PT.db666437.png";